import pino from 'pino'
import {LOG_INTERVAL, Logger} from "@/lib/logging/logging-types";

let logger: Logger;
const loggedMessages = new Map<string, number>();

export function sLog() {
    if (!logger && isServer()) {
        // @ts-expect-error msg parameter string or object
        logger = initLogger();
    }
    return {
        debug: deduplicateLog('debug'),
        info: deduplicateLog('info'),
        warn: deduplicateLog('warn'),
        error: deduplicateLog('error'),
    }
}


function deduplicateLog(level: keyof Logger) {
    return (msg: string, obj?: Record<string, unknown>) => {
        const key = `${level}:${msg}`;
        const now = Date.now();

        const lastLogged = loggedMessages.get(key);
        if (!lastLogged || now - lastLogged > LOG_INTERVAL) {
            loggedMessages.set(key, now);

            logger[level]({
                msg,
                details: obj
            })
        }
    };
}

export function initLogger() {
    return pino({
        base: null,
        level: process.env.NEXT_PUBLIC_LOG_LEVEL ?? 'info',
    });
}

function isServer() {
    return typeof window === 'undefined';
}
